import { useUserProfile } from "@/hooks/query/useUserProfile";
import { RootState } from "@/redux";
import { FC, useMemo } from "react";
import { useSelector } from "react-redux";
import { getSidebarRoutes } from "../sidebarRoutes";
import { SidebarItem } from "./SidebarItem";

const SidebarNav: FC = () => {
  const { data: profile } = useUserProfile();

  const activeAccount = useSelector(
    (state: RootState) => state.activeAccount.currentAccount
  );

  const mappedRoutes = useMemo(() => {
    const routes = [...getSidebarRoutes(activeAccount)];
    return routes;
  }, [activeAccount]);

  return (
    <div className="flex flex-col gap-2">
      {mappedRoutes.map((route) => (
        <SidebarItem
          key={route.id}
          item={route}
          profile={profile}
        />
      ))}
    </div>
  );
};

export default SidebarNav;
